

















































































































import {Component, Vue} from 'vue-property-decorator';
import {HomeOver} from '@/static/home';
import {CourseRouterPath} from '@/router/official';

@Component
export default class HomeCourseView extends Vue {
  /**首页课程*/
  private courseData = HomeOver.course;

  // 普通方法
  greet() {
  }

  /**查看课程*/
  public courseClick(id: string) {
    this.$router.push({name: CourseRouterPath.OFFICIAL_COURSE_CATALOG_VIEW, params: {id: id}});
  }

}
